import Box from '@material-ui/core/Box';
import React from 'react';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import useTelemetryOperationMetaData from '../../telemetry/hooks';
import TelemetryCharts from '../../telemetry/charts/TelemetryCharts';

const TelemetryMetaData = ({
    dataSourceStatus,
    dataSetConfigId
}) => {
    if (dataSourceStatus == null || dataSourceStatus.dataSetConfigs == null) {
        return null;
    }

    const statuses = dataSourceStatus.dataSetConfigs || [];
    const dataSetStatus = statuses.find(
        (status) => status.dataSetConfigId === Number(dataSetConfigId)
    );

    if (dataSetStatus == null || dataSetStatus.lastRunInfo == null) {
        return null;
    }

    const { operationId } = dataSetStatus.lastRunInfo;
    const [{ data, isLoading, isError }] = useTelemetryOperationMetaData(operationId);

    if (isLoading) {
        return <div>Loading telemetry data...</div>;
    }

    return (
        <Box>
            <Typography variant="h5">Previous Run :&nbsp;</Typography>
            <Divider />
            <Box mt={2}>
                {/* Always show Operation Id */}
                <Typography variant="body2">
                    <Box component="span" fontWeight="bold">
                        Operation Id :&nbsp;
                    </Box>
                    {operationId}
                </Typography>

                {isError && (
                    <Typography variant="body2" color="error">
                        Error loading telemetry data
                    </Typography>
                )}

                {data?.success && (
                    <>
                        <Typography variant="body2">
                            <Box component="span" fontWeight="bold">
                                Total Entities Processed :&nbsp;
                            </Box>
                            {data.data.totalEntitiesProcessed}
                        </Typography>

                        <Typography variant="body2">
                            <Box component="span" fontWeight="bold">
                                Operation Started (UTC) :
                            </Box>
                            &nbsp;
                            {data.data.operationStartTime}
                        </Typography>

                        <Typography variant="body2">
                            <Box component="span" fontWeight="bold">
                                Operation Completed (UTC) :
                            </Box>
                            &nbsp;
                            {data.data.operationEndTime}
                        </Typography>
                    </>
                )}
            </Box>
            <TelemetryCharts telemetryData={data.data} />
        </Box>
    );
};

export default TelemetryMetaData;
